module.exports = __webpack_public_path__ + "images/c892c4bf046cdaed9bbb67a26f731fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/mythos-story00.jpg
// module id = ./webpack/assets/img/mythos-story00.jpg
// module chunks = 0